import * as yup from 'yup';

export type TTradingPlatform = {
  id?: number;
  name: string;
  type?: string;
  content: string;
  is_publish?: boolean;
};

export type TTradingPlatformsRes = {
  total: number;
  platforms: TTradingPlatform[];
  has_next: boolean;
  total_pages: number;
  current_page: number;
};

export type TTradingPlatformQuery = {
  page?: number;
  size?: number;
};

export type TTradingPlatformFormData = {
  name: string;
  type?: string;
  content: string;
  is_publish?: boolean;
};

export const schemaTradingPlatform = yup.object().shape({
  name: yup.string().required('Name is required'),
  type: yup.string().optional(),
  content: yup.string().required('Content is required'),
  is_publish: yup.boolean().optional(),
});
